<rt-sidebar class="sidebar-create" [hasExpander]="false">
  <rt-heading class="sidebar-create--heading" variant="heading large-x">
    {{ 'app.views.view_page.new_view' | translate }}
  </rt-heading>
  <rt-divider />
  <div class="sidebar-create--body">
    <rt-views-view-name-input
      [nameControl]="viewForm.controls.name"
      [symbolControl]="viewForm.controls.symbol"
      [layoutType]="viewForm.value.layout!.type!"
    />
    <rt-views-view-layout-picker
      [formControl]="viewForm.controls.layout.controls.type"
      [layouts]="dataSource.layouts"
      margin-top
    />
    <rt-heading margin-top>
      {{ 'app.views.view_page.visibility_options' | translate }}
    </rt-heading>
    <rt-visibility-selector-container
      [visibility]="viewForm.controls.visibility.value"
      [labels]="visibilityLabels"
      protectedUsersPosition="inside"
      (visibilityChanges)="onVisibilityChanges($event)"
      buttonVariant="outline"
      margin-top-small-x
    />
  </div>
  <rt-divider />
  <div class="sidebar-create--body">
    <rt-button variant="primary" (click)="createView()">
      {{ 'app.views.view_page.save_view' | translate }}
    </rt-button>
    <a rt-button variant="plain" margin-top-small-x (mousedown)="cancel()">
      {{ 'app.common.cancel' | translate }}
    </a>
  </div>
</rt-sidebar>
